export const normalizeEmail = value => (value || '').trim().toLowerCase();
